/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { format as formatDate } from 'my-phorest/utils/local-date-helpers';
import { durationBetween } from 'my-phorest/utils/local-datetime-helpers';
import { service } from '@ember/service';

export default class MessagesListComponent extends Component {
  @service intl;
  @service twoWayChat;
  @service branchTime;

  get hoursRemainingInHandoff() {
    const conversation = this.twoWayChat.selectedConversation;
    const humanHandoffUntil = conversation?.humanHandoffUntil;

    if (!conversation?.isHumanHandoff || !humanHandoffUntil) {
      return 0;
    }

    const duration = durationBetween(
      humanHandoffUntil,
      this.branchTime.dateAndTime
    );
    const hoursRemaining = duration?.asHours() ?? 0;

    return hoursRemaining > 0 ? Math.ceil(hoursRemaining) : 0;
  }

  get showHandoffSeparator() {
    return (
      this.twoWayChat.selectedConversation?.isHumanHandoff &&
      this.hoursRemainingInHandoff > 0
    );
  }

  get messagesWithSeparators() {
    let chatMessages = this.args.chatMessages || [];
    const itemsWithSeparators = [];

    chatMessages = chatMessages.sort(
      (a, b) =>
        new Date(b.message.sentDateTime) - new Date(a.message.sentDateTime)
    );

    for (let i = chatMessages.length - 1; i >= 0; i--) {
      const currentMessage = chatMessages[i].message;
      const nextMessage =
        i < chatMessages.length - 1 ? chatMessages[i + 1].message : null;

      if (
        i === chatMessages.length - 1 ||
        (nextMessage &&
          this.#isDifferentDay(
            currentMessage.sentDateTime,
            nextMessage.sentDateTime
          ))
      ) {
        itemsWithSeparators.push({
          type: 'separator',
          variant: 'secondary',
          text: this.#getDisplayDate(currentMessage.sentDateTime),
        });
      }

      if (nextMessage?.isMessageSeen && !currentMessage.isMessageSeen) {
        itemsWithSeparators.push({
          type: 'separator',
          variant: 'primary',
          text: this.intl.t('two-way-chat.unread'),
        });
      }

      itemsWithSeparators.push(chatMessages[i]);
    }

    return itemsWithSeparators.reverse();
  }

  #isDifferentDay(date1, date2) {
    return new Date(date1).toDateString() !== new Date(date2).toDateString();
  }

  #getDisplayDate(date) {
    const currentDate = new Date(date);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (currentDate.toDateString() === today.toDateString()) {
      return this.intl.t('global.today');
    } else if (currentDate.toDateString() === yesterday.toDateString()) {
      return this.intl.t('global.yesterday');
    } else {
      return formatDate(date, this.intl, 'short');
    }
  }
}
